const themes = {
  light: {
    primary: '#1F6372',
    secondary: '#d7dfea',
    accent: '#d48867',
    contrast: '#E76D83',
    dimmed: '#757575',
    default: '#2f2f2f',
    strong: '#000000',
    invert: '#ffffff',
    anchor: '#000000',
    label: '#165D6E',
    highlight: '#94C8D5',
    selection: '#1d4879',
    selectionLight: '#3162AF',
    primaryBackground: '#fff',
    secondaryBackground: '#eceff2',
    ternaryBackground: '#F7F8FA',
    buttonBackground: '#D7DBE0',
    mTabsBackground: '#EDF0F4',
    searchBoxBackground: '#F7F8FA',
    inputBackground: '#eeeeee',
    inputFocusBackground: '#ffffff',
    inputBorder: '#dddddd',
    // Vue 3 needs explicit lighten/darken variants
    // Vue 2 auto-generated these from inputBorder
    'inputBorder-lighten-2': '#e8e8e8',
    'inputBorder-darken-1': '#c4c4c4',
    menuBackground: '#F7F8FA',
    channelLabel: '#0070fa',
    dropZoneBackground: '#F7F8FA',
    recordingBackground: '#D7DBE0',
    ongoingRecordingBackground: '#fdd8d8',
    futureRecordingBackground: '#fdfbd8',
    nodeSelectionBackground: '#CFCFCF',
    hoverEffect: '#eeeff1',
    error: '#ff5252'
  },
  dark: {
    primary: '#5DAEC1',
    secondary: '#163440',
    accent: '#EDB9A3',
    contrast: '#E76D83',
    dimmed: '#818B95',
    default: '#d0d8e0',
    strong: '#ffffff',
    invert: '#000000',
    anchor: '#ffffff',
    label: '#94C8D5',
    highlight: '#21859c',
    selection: '#1d4879',
    selectionLight: '#3162AF',
    primaryBackground: '#121921',
    secondaryBackground: '#222A32',
    ternaryBackground: '#333B43',
    buttonBackground: '#49535d',
    mTabsBackground: '#1b2530',
    searchBoxBackground: '#d0d8e0',
    inputBackground: '#1a1f25',
    inputFocusBackground: '#121921',
    inputBorder: '#1a1f25',
    // Vue 3 needs explicit lighten/darken variants
    // Vue 2 auto-generated these from inputBorder
    'inputBorder-lighten-2': '#454b53',
    'inputBorder-darken-1': '#0f1318',
    menuBackground: '#19222C',
    channelLabel: '#FB8C00',
    dropZoneBackground: '#000',
    recordingBackground: '#333B43',
    ongoingRecordingBackground: '#371a1f',
    futureRecordingBackground: '#3f4538',
    nodeSelectionBackground: '#434a52',
    hoverEffect: '#434a52',
    error: '#ff5252'
  }
};

const themes_v3 = {
  light: {
    dark: false,
    colors: themes.light
  },
  dark: {
    dark: true,
    colors: themes.dark
  }
};

export default import.meta.env.VUE_APP_V2 ? themes : themes_v3;
